// extracted by mini-css-extract-plugin
export var grid = "_k-0";
export var span1 = "_k-2";
export var span10 = "_k-b";
export var span10L = "_k-z";
export var span10M = "_k-n";
export var span10Xl = "_k-1b";
export var span11 = "_k-c";
export var span11L = "_k-10";
export var span11M = "_k-o";
export var span11Xl = "_k-1c";
export var span12 = "_k-d";
export var span12L = "_k-11";
export var span12M = "_k-p";
export var span12Xl = "_k-1d";
export var span1L = "_k-q";
export var span1M = "_k-e";
export var span1Xl = "_k-12";
export var span2 = "_k-3";
export var span2L = "_k-r";
export var span2M = "_k-f";
export var span2Xl = "_k-13";
export var span3 = "_k-4";
export var span3L = "_k-s";
export var span3M = "_k-g";
export var span3Xl = "_k-14";
export var span4 = "_k-5";
export var span4L = "_k-t";
export var span4M = "_k-h";
export var span4Xl = "_k-15";
export var span5 = "_k-6";
export var span5L = "_k-u";
export var span5M = "_k-i";
export var span5Xl = "_k-16";
export var span6 = "_k-7";
export var span6L = "_k-v";
export var span6M = "_k-j";
export var span6Xl = "_k-17";
export var span7 = "_k-8";
export var span7L = "_k-w";
export var span7M = "_k-k";
export var span7Xl = "_k-18";
export var span8 = "_k-9";
export var span8L = "_k-x";
export var span8M = "_k-l";
export var span8Xl = "_k-19";
export var span9 = "_k-a";
export var span9L = "_k-y";
export var span9M = "_k-m";
export var span9Xl = "_k-1a";
export var stretch = "_k-1";